var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { BreadcrumbJsonLd, CarouselJsonLd, DefaultSeo as NextDefaultSeo, NextSeo, ProductJsonLd, } from 'next-seo';
import React from 'react';
import defaultConfig, { getJsonLdData, twitterConfig } from './config';
var DefaultSeo = function () { return React.createElement(NextDefaultSeo, __assign({}, defaultConfig)); };
var SEOJsonLd = function (_a) {
    var title = _a.title, description = _a.description, productDescription = _a.productDescription, price = _a.price, productPageUrl = _a.productPageUrl, jsonLdImages = _a.jsonLdImages, stockStatus = _a.stockStatus, reviewSummary = _a.reviewSummary;
    var productName = title ? "".concat(title, " ").concat(description) : description;
    var _b = getJsonLdData(stockStatus, price, reviewSummary), aggRating = _b.aggRating, offers = _b.offers;
    return (React.createElement(ProductJsonLd, { productName: productName, type: "Product", description: productDescription, images: jsonLdImages, aggregateRating: aggRating, offers: offers, url: productPageUrl }));
};
var SEOCarouselJsonLd = function (_a) {
    var data = _a.data;
    return React.createElement(CarouselJsonLd, { ofType: "default", data: data });
};
var SEOBreadcrumbJsonLd = function (_a) {
    var data = _a.data;
    return React.createElement(BreadcrumbJsonLd, { itemListElements: data });
};
var Seo = function (props) {
    var _a, _b, _c;
    var _d = props.matureContent, matureContent = _d === void 0 ? false : _d, twitterHandle = props.twitterHandle, nextSeoProps = __rest(props, ["matureContent", "twitterHandle"]);
    // Adjust twitter config
    var twitter = twitterConfig(matureContent, twitterHandle);
    // Ensure there's always an OpenGraph title
    var openGraph = __assign(__assign({}, ((_a = nextSeoProps === null || nextSeoProps === void 0 ? void 0 : nextSeoProps.openGraph) !== null && _a !== void 0 ? _a : {})), { title: (_c = (_b = nextSeoProps === null || nextSeoProps === void 0 ? void 0 : nextSeoProps.openGraph) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : nextSeoProps.title });
    return React.createElement(NextSeo, __assign({}, nextSeoProps, { twitter: twitter, openGraph: openGraph }));
};
export { DefaultSeo, Seo, SEOJsonLd, SEOCarouselJsonLd, SEOBreadcrumbJsonLd };
export * from './types';
